import React from "react";
import { Bar } from "react-chartjs-2";

export const MyResponsiveBar = ({ data, origin } ) => {
  
  let data1;
  if (data !== 0) {
    if (origin === "AvgTimePerUser") {
      let dataEntry = [];
      let dataEntry2 = [];
      let label = [];

      for (const item of data) {
        dataEntry.push(item.acknowlegedTime);
        dataEntry2.push(item.closureTime);
        label.push(item.userEmail);
      }
      data1 = {
        datasets: [
          {
            backgroundColor: "#01579B",
            data: dataEntry,
            label: "Μέσος Χρόνος Ανάθεσης",
          },
          {
            backgroundColor: "#0288D1",
            data: dataEntry2,
            label: "Μέσος Χρόνος Κλεισίματος",
          },
        ],
        labels: label,
      };
    } else if (origin === "AvgTime") {
      data1 = {
        datasets: [
          {
            backgroundColor: "#01579B",
            data: [data[0].acknowlegedTime],
            label: "Μέσος Χρόνος Ανάθεσης",
          },
          {
            backgroundColor: "#0288D1",
            data: [data[0].closureTime],
            label: "Μέσος Χρόνος Κλεισίματος",
          },
        ],
        labels: ["Χρόνος απόκρισης σε λεπτά"],
      };
    } else if (origin === "Counts") {
      let dataEntry = [];
      let dataEntry2 = [];
      let label = [];

      for (const item of data) {
        dataEntry.push(item.cntOfAcknowledged);
        dataEntry2.push(item.cntOfClosed);
        label.push(item.email);
      }
      data1 = {
        datasets: [
          {
            backgroundColor: "#01579B",
            data: dataEntry,
            label: "Πλήθος Ανοιχτών Ειδοποιήσεων",
          },
          {
            backgroundColor: "#0288D1",
            data: dataEntry2,
            label: "Πλήθος Κλειστών Ειδοποιήσεων",
          },
        ],
        labels: label,
      };
    } else if (origin === "Type") {
      data1 = {
        datasets: [
          {
            backgroundColor: "#f44336",
            data: data.map((data) =>{return data.cntHighRisk})
          ,
            label: "Υψηλός Κίνδυνος",
          },
          {
            backgroundColor: "#e67e22",
            data: data.map((data) =>{return data.cntModerateRisk}),
            label: "Μέτριος Κίνδυνος",
          },
          {
            backgroundColor: "#f1c40f",
            data: data.map((data) =>{return data.cntLowRisk}),
            label: "Χαμηλός Κίνδυνος",
          },
        ],
        labels:   data.map((data) =>{return data.label}),
        
        
      };
    }
  }

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: true },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          barThickness: 10,
          maxBarThickness: 10,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {},
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            min: 0,
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
          },
        },
      ],
    },
  };
  if (data.length !== 0) {
    return <Bar data={data1} options={options} />;
  } else {
    return <h1>Δεν υπάρχουν δεδομένα</h1>;
  }
};
